import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';
import { canPerformAction } from './validators/functions/can-perform-action.function';

export * from './dtos/create-supplier.dto';
export * from './dtos/suppliers-stats.dto';
export * from './dtos/supplier-list.dto';
export * from './dtos/supplier-record.dto';
export * from './dtos/supplier-activity-event.dto';
export * from './dtos/supplier-activity-event-hydration.dto';
export * from './dtos/supplier-search.dto';
export * from './dtos/update-supplier.dto';

export * from './enums/supplier-type.enum';
export * from './enums/supplier-status.enum';
export * from './enums/supplier-action.enum';

export * from './functions/supplier-status-to-color.function';

export * from './types/suppliers-filters';

export * from './validators/schemas/create-supplier.schema';
export * from './validators/schemas/update-supplier.schema';

export const supplierValidators = { canCreateOrUpdate, canPerformAction };
